<div class="edit-modal-content">
  <ng-content></ng-content>
</div>